<template>
  <div class="c-config-input-type u-block">
    <div class="c-config-input-info c-config-input-info-full u-margin-0">
      <label>{{ input.label }}</label>
      <p>{{ input.description }}</p>
    </div>

    <image-with-preview-field
      :key="input.value"
      :accept="['.jpg', '.jpeg', '.png', '.gif', '.webp']"
      :image-path="imagePreviewUrl"
      :image-name="imageName"
      placeholder="Click to select registration background image"
      :disabled="disabled"
      :crop-width="955"
      :crop-height="1000"
      @onChange="handleImageChange"
    />

    <div class="format-info">
      <p>✓ Supported formats: <strong>JPG • PNG • GIF • WebP</strong></p>
      <p>✓ Image will be cropped to <strong>955 x 1000</strong> px before saving</p>
      <p v-if="pendingFile">
        ✓ Image will be uploaded when you click Submit
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ImageWithPreviewField from '@/shared/custom-form-fields/ImageWithPreviewField.vue';
import { configurationsService } from '@/services/configurations';
import config from '../../../config/local';

export default {
  name: 'RegistrationBackgroundFormField',

  components: {
    ImageWithPreviewField,
  },

  props: {
    input: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    languages: {
      type: Array,
      required: false
    }
  },

  data() {
    return {
      uploading: false,
      pendingFile: null,
      uploadError: '',
    };
  },

  computed: {
    imagePreviewUrl() {
      if (this.pendingFile === 'DELETE') {
        return '';
      }

      return this.input.value ? `${config.BASE_URL}/${this.input.value}` : '';
    },
    imageName() {
      if (this.pendingFile === 'DELETE') {
        return '';
      }

      if (this.pendingFile && this.pendingFile !== 'DELETE') {
        return this.pendingFile.name;
      }

      return this.input.value ? this.input.value.split('/').pop() : '';
    }
  },

  methods: {
    ...mapActions('response', ['setGlobalError']),

    handleImageChange(file) {
      this.uploadError = '';

      if (!file) {
        this.pendingFile = 'DELETE';
        this.$emit('update', { value: this.input.value, isValid: true });
        return;
      }

      this.pendingFile = file;
      this.$emit('update', { value: this.input.value, isValid: true });
    },

    async uploadPendingImage() {
      if (!this.pendingFile) {
        return;
      }

      if (this.pendingFile === 'DELETE') {
        this.$emit('update', { value: '' });
        return;
      }

      const file = this.pendingFile;

      try {
        this.uploading = true;
        const formData = new FormData();
        formData.append('file', file, file.name);

        const response = await configurationsService.saveRegistrationBackgroundImage(this.$route.params.id, formData);
        const imagePath = response.data.image.imagePath;

        this.pendingFile = null;
        this.$emit('update', { value: imagePath });
      } catch (error) {
        this.setGlobalError(error?.data?.message || 'Failed to upload registration background image.');
        throw error;
      } finally {
        this.uploading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.format-info {
  margin-top: 1.5rem;
  padding: 1rem;
  background: #f0f0f0;
  border-radius: 4px;
  font-size: 1.3rem;
  color: #555;

  small {
    display: block;
    font-size: 1rem;
  }

  strong {
    color: #333;
    font-weight: 600;
  }
}
</style>
